import React, { Component } from 'react';
import { compose, mapProps } from 'recompose';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';
import { roundCurrency } from '../Common/Helper';
import config from '../../config';
import { HTMLTrans } from '../Common/Translations';

export const withCurrency = compose(mapProps(({
  store: {
    currency: {
      code = '',
    } = {},
  } = {}, ...props
}) => ({
  currencyCode: code,
  ...props,
})));


class Avatar extends Component {
  render() {
    const {
      userHeaderInfo: {
        creditBalance = 0,
        defaultProfilePicture = '',
      },
      currencyCode,
      avatarImg = defaultProfilePicture || `${config.s3BucketUrl}/dashboards/avatar.svg`,
      globalShippingCreditEnabled,
      shippingCreditCurrency,
      shippingCreditBalance,
    } = this.props;
    return (
      <div>
        <div className="pb-3">
          <img className="d-none d-lg-inline-block rounded-circle avatar" src={avatarImg} />
        </div>
        <h3 className="ProximaNova-Bold text-uppercase d-none d-lg-block"><HTMLTrans id="account.avatar_mydashboard">My Dashboard</HTMLTrans></h3>
        <p className="mb-0"><HTMLTrans id="account.avatar_storecreditbalance">Store Credit Balance:</HTMLTrans></p>
        <h3 className="ProximaNova-Bold text-uppercase">{currencyCode} {roundCurrency(creditBalance)}</h3>

        {globalShippingCreditEnabled && (
          <p className="mb-0">
            <span className="shipping-credit-expiry-modal-trigger" data-toggle="modal" data-target="#shipping-credit-expiry-modal">
              <HTMLTrans id="account.avatar_shippingcreditbalance">Shipping Credit Balance:</HTMLTrans>
              <i className="shipping-credit-expiry-modal-trigger__icon ml-1 fa fa-question-circle" aria-hidden="true"></i>
            </span>
          </p>
        )}

        {globalShippingCreditEnabled && <h3 className="ProximaNova-Bold text-uppercase">{shippingCreditCurrency} {roundCurrency(shippingCreditBalance)}</h3>}
      </div>
    );
  }
}

const enhance = compose(
  withStoreDetail,
  withCurrency,
);
export default enhance(Avatar);
export const undecorated = Avatar;



// WEBPACK FOOTER //
// ./src/Account/Avatar.js